import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import Select from 'components/Select/desktop';
import Button from 'components/Button';
import InputDate from 'components/InputDate/desktop';
import SearchUserInput from 'components/SearchUserInput/SearchUserInput';
import SVG from 'components/SVG';

import DaysFilter from '../../../../DaysFilter';
import { diffRangeItems, generalReportDaysFilterValue } from 'features/reports/data';
import compareSVG from 'features/reports/img/compare.svg';
import arrowSVG from 'features/reports/img/arrow.svg';
import saveSVG from 'features/reports/img/save.svg';

import './FilterBlock.scss';

const b = block('filter-block');

const FilterBlock = ({
  isMobile,
  handleFormSubmit,
  handleKeyDown,
  handleStructureChange,
  handleSearchChange,
  handleResultClick,
  onChangeBeginDate,
  onChangeEndDate,
  onChangeActiveDay,
  onChangeDiffRange,
  onChangeBeginDiffDate,
  onChangeEndDiffDate,
  handleSetWithDiff,
  handleGetDiff,
  handleSetSaveFilterOpen,
  values,
  children,
}) => {
  const locale = useSelector(state => state.locale.locale);
  const {
    activeDay,
    activeDiffRange,
    structure,
    filters,
    filterValue,
    searchResult,
    isLoadingSearchResult,
    date,
    diffDate,
    withDiff,
  } = values;

  return (
    <form className={b({ isMobile })} onSubmit={handleFormSubmit} onKeyDown={handleKeyDown} tabIndex={0}>
      <div className={b('header-row')}>
        <div className={b('header')}>{locale.filter}</div>

        <div className={b('header-controls')}>
          {withDiff && (
            <div className={b('compare-controls')}>
              {activeDiffRange.name === 'manualCompare' && (
                <div className={b('date-row')}>
                  <div className={b('field')}>
                    <div className={b('date-input')}>
                      <InputDate
                        selected={diffDate.beginDate}
                        onChange={onChangeBeginDiffDate}
                        title={locale.from}
                        fontSize={12}
                      />
                    </div>
                  </div>
                  <div className={b('field')}>
                    <div className={b('date-input')}>
                      <InputDate
                        selected={diffDate.endDate}
                        onChange={onChangeEndDiffDate}
                        title={locale.to}
                        fontSize={12}
                      />
                    </div>
                  </div>
                </div>
              )}
              <div className={b('compare-select')}>
                <Select
                  items={diffRangeItems[activeDay.text || 'manualCompare']}
                  activeItem={activeDiffRange}
                  onChange={onChangeDiffRange}
                />
              </div>
            </div>
          )}

          <div className={b('actions')}>
            {!withDiff ? (
              <Button
                callBack={handleGetDiff}
                text={
                  <span className={b('button-content')}>
                    <SVG className={b('button-icon')} svgProps={{ svg: compareSVG }} />
                    {locale.compare}
                  </span>
                }
              />
            ) : (
              <Button
                callBack={() => handleSetWithDiff(false)}
                color="bordered"
                text={
                  <span className={b('button-content')}>
                    <SVG className={b('button-icon')} svgProps={{ svg: arrowSVG }} />
                    {locale.standardValues}
                  </span>
                }
              />
            )}
            <Button
              callBack={() => handleSetSaveFilterOpen(true)}
              text={
                <span className={b('button-content')}>
                  <SVG className={b('button-icon')} svgProps={{ svg: saveSVG }} />
                  {locale.saveFilters}
                </span>
              }
            />
          </div>
        </div>
      </div>

      <div className={b('primary')}>
        <div className={b('date-row')}>
          <div className={b('field')}>
            <div className={b('title')}>{locale.dateFrom}</div>
            <div className={b('date-input')}>
              <InputDate selected={date.beginDate} onChange={onChangeBeginDate} />
            </div>
          </div>
          <div className={b('field')}>
            <div className={b('title')}>{locale.dateTo}</div>
            <div className={b('date-input')}>
              <InputDate selected={date.endDate} onChange={onChangeEndDate} />
            </div>
          </div>
        </div>
        <div className={b('apply')}>
          <Button size="low" text={locale.acceptFilter} type="submit" />
        </div>
      </div>

      {isMobile && (
        <div className={b('secondary')}>
          <div className={b('field')}>
            <div className={b('title')}>{locale.show}</div>
            <Select
              name="structure"
              items={structure}
              activeItem={filters.structure}
              onChange={handleStructureChange}
            />
          </div>
          <div className={b('field')}>
            <div className={b('title')}>{locale.agent}</div>
            <SearchUserInput
              filterValue={filterValue}
              handleSearchChange={handleSearchChange}
              handleResultClick={handleResultClick}
              searchResult={searchResult}
              isLoadingSearchResult={isLoadingSearchResult}
              placeholder={locale.agent}
              locale={locale}
            />
          </div>
        </div>
      )}

      <DaysFilter
        activeDay={activeDay}
        setActiveDay={onChangeActiveDay}
        isMobile={isMobile}
        items={generalReportDaysFilterValue}
      />

      {children}
    </form>
  );
};

export default FilterBlock;
